'use strict';
module.exports = function () {
	return /(?:(?:\u001b\[)|\u009b)(?:(?:[0-9]{1,3})?(?:(?:;[0-9]{0,3})*)?[A-M|f-m])|\u001b[A-M]/g;
};



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/strip-ansi/~/ansi-regex/index.js
 ** module id = 55
 ** module chunks = 0
 **/